module.exports = __webpack_public_path__ + "static/media/bleed_img.e4fff9c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/bleed_img.png
// module id = 1807
// module chunks = 68